import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { getVendorDetails } from '../../../store/actions/shared/Shared';
import SingleProducts from './products';
import Loader from 'react-loader-spinner';
import {
  getAllProducts,
  getSubCategory,
  getSubCategoryProducts
} from '../../../store/actions/user/User';
import store from '../../../store/reducers/rootReducer';
import { Waypoint } from 'react-waypoint';
import SkeletonLoad from '../Preloader/SkeletonLoad';
class Shop extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
  }

  state = {
    show: false,
    isOpen: false,
    subCategory: 'all',
    thePosition: false,
    previousSubCategory: 'all'
  };

  componentWillMount() {
    var category = this.props.match.params.category;
    var uid = this.props.match.params.uid;
    var subCategory = this.props.match.params.subCategory;

    this.props.getVendorDetails(uid);

    if (category !== 'Liquor') {
      if (subCategory === 'all') {
        this.props.getAllProducts(category, uid);
      } else {
        this.props.getSubCategoryProducts(category, uid, subCategory);
      }
    } else {
      this.props.getAllProducts(category, uid);
    }
    this.props.getSubCategory(category, uid);
    // setTimeout(() => this.setState({isLoading:false}),2000);
    document.addEventListener('scroll', () => {
      if (window.scrollY > 329) {
        this.setState({ thePosition: true });
      } else {
        this.setState({ thePosition: false });
      }
    });
    window.scrollTo(0, 0);
  }
  onPressCategory = () => {
    window.scrollTo({ top: 331, behavior: 'smooth' });
  };

  onScrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };
  handle = (e, product, index) => {
    e.preventDefault();
    product = {
      ...product,
      mrp: product.mrp[index],
      price: product.price[index],
      description: product.description[index],
      image: product.image[index],
      stock: product.stock[index],
      index: index
    };

    if (localStorage.getItem('cart')) {
      var setcart = JSON.parse(localStorage.getItem('cart'));
      var container = setcart.filter(
        (item) => item.description === product.description
      );
      if (container.length === 0) {
        setcart[setcart.length] = { ...product, quantity: 1 };
        localStorage.setItem('cart', JSON.stringify(setcart));
        store.dispatch({ type: 'ADD_TO_CART', payload: { data: setcart } });
      }
    } else {
      var addtolocal = [{ ...product, quantity: 1 }];
      localStorage.setItem('cart', JSON.stringify(addtolocal));
      store.dispatch({ type: 'ADD_TO_CART', payload: { data: addtolocal } });
    }
  };

  handleRangeChange = (event) => {
    const maxvalue = event.target.value;
    this.setState({ ...this.state, maxvalue: maxvalue });
  };

  changeSubcategory = (subCategory) => {
    var category = this.props.match.params.category;
    var uid = this.props.match.params.uid;

    if (subCategory === 'all') {
      this.props.getAllProducts(category, uid);
    } else {
      this.props.getSubCategoryProducts(category, uid, subCategory);
    }
  };
  goto = (ele) => {
    let offsetTop = document.getElementById(ele).offsetTop;
    var scr = document.getElementById('scrollingDiv');
    scr.scrollTo({
      top: offsetTop,
      behavior: 'smooth'
    });
  };

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };
  showAll = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  render() {
    const { auth } = this.props;
    // if (this.state.isLoading) return <Loader/>
    var difference;
    if (this.props.vendor.closetime) {
      if (this.props.vendor.closetime.includes('pm')) {
        var openHours, openMin;
        var closeHours = parseInt(
          this.props.vendor.closetime.substring(
            0,
            this.props.vendor.closetime.indexOf(':')
          )
        );
        closeHours = closeHours === 12 ? closeHours : closeHours + 12;
        const closeMin = parseInt(
          this.props.vendor.closetime.substring(
            this.props.vendor.closetime.indexOf(':') + 1,
            this.props.vendor.closetime.indexOf(':') + 3
          )
        );
        // const openHours = (parseInt(props.vendor.opentime.substring(0,props.vendor.opentime.indexOf(':')))+12)*60
        // const openMin   = parseInt(props.vendor.opentime.substring(props.vendor.opentime.indexOf(':')+1,props.vendor.opentime.indexOf(':')+3))
        if (this.props.vendor.opentime.includes('am')) {
          openHours = parseInt(
            this.props.vendor.opentime.substring(
              0,
              this.props.vendor.opentime.indexOf(':')
            )
          );
          openHours = openHours === 12 ? 0 : openHours;
          closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
          // openHours*=60;
          openMin = parseInt(
            this.props.vendor.opentime.substring(
              this.props.vendor.opentime.indexOf(':') + 1,
              this.props.vendor.opentime.indexOf(':') + 3
            )
          );
        } else {
          openHours = parseInt(
            this.props.vendor.opentime.substring(
              0,
              this.props.vendor.opentime.indexOf(':')
            )
          );
          openHours = openHours === 12 ? openHours : openHours + 12;
          closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
          // openHours*=60;
          openMin = parseInt(
            this.props.vendor.opentime.substring(
              this.props.vendor.opentime.indexOf(':') + 1,
              this.props.vendor.opentime.indexOf(':') + 3
            )
          );
        }
        closeHours *= 60;
        openHours *= 60;

        const currentHours = new Date().getHours() * 60;
        const currentMinutes = new Date().getMinutes();

        const today = new Date().getDay().toString();
        if (
          this.props.vendor.days &&
          this.props.vendor.days.indexOf(today) === -1
        ) {
          difference = -1;
        } else if (openHours + openMin === closeHours + closeMin) {
          difference = 1;
        } else if (
          currentHours + currentMinutes > openHours + openMin &&
          currentHours + currentMinutes < closeHours + closeMin
        ) {
          difference = 1;
        } else {
          difference = -1;
        }
      } // if time in A.M.
      else {
        var closeHours = parseInt(
          this.props.vendor.closetime.substring(
            0,
            this.props.vendor.closetime.indexOf(':')
          )
        );
        closeHours = closeHours === 12 ? 0 : closeHours;
        const closeMin = parseInt(
          this.props.vendor.closetime.substring(
            this.props.vendor.closetime.indexOf(':') + 1,
            this.props.vendor.closetime.indexOf(':') + 3
          )
        );
        const currentHours = new Date().getHours() * 60;
        const currentMinutes = new Date().getMinutes();
        if (this.props.vendor.opentime.includes('am')) {
          openHours = parseInt(
            this.props.vendor.opentime.substring(
              0,
              this.props.vendor.opentime.indexOf(':')
            )
          );
          openHours = openHours === 12 ? 0 : openHours;
          closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
          openHours *= 60;
          openMin = parseInt(
            this.props.vendor.opentime.substring(
              this.props.vendor.opentime.indexOf(':') + 1,
              this.props.vendor.opentime.indexOf(':') + 3
            )
          );
        } else {
          openHours = parseInt(
            this.props.vendor.opentime.substring(
              0,
              this.props.vendor.opentime.indexOf(':')
            )
          );
          openHours = openHours === 12 ? openHours : openHours + 12;
          closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
          openMin = parseInt(
            this.props.vendor.opentime.substring(
              this.props.vendor.opentime.indexOf(':') + 1,
              this.props.vendor.opentime.indexOf(':') + 3
            )
          );
        }

        closeHours *= 60;

        const today = new Date().getDay().toString();
        if (
          this.props.vendor.days &&
          this.props.vendor.days.indexOf(today) === -1
        ) {
          difference = -1;
        } else if (openHours + openMin === closeHours + closeMin) {
          difference = 1;
        } else if (
          currentHours + currentMinutes > openHours + openMin &&
          currentHours + currentMinutes < closeHours + closeMin
        ) {
          difference = 1;
        } else {
          difference = -1;
        }
      }
    }

    const {
      grocery_products,
      medicine_products,
      restaurant_products,
      food_products,
      champagne_products,
      mixeddrinks_products,
      redwine_products,
      spirits_products,
      whitewine_products,
      grocery_subcategory,
      medicine_subcategory,
      restaurant_subcategory,
      food_subcategory,
      cider_subcategory,
      liquor_products,
      champagne_subcategory,
      mixeddrinks_subcategory,
      liquor_subcategory,
      redwine_subcategory,
      spirits_subcategory,
      whitewine_subcategory,
      laundry_products,
      laundry_subcategory,
      meat_products,
      meat_subcategory
    } = this.props.products;

    let category = this.props.match.params.category;
    let liquor_filter = liquor_products.filter(
      (product) =>
        product.super_category === this.props.match.params.subCategory
    );

    if (!localStorage.getItem('city')) return <Redirect to="/" />;
    return (
      <div
        className="container-fluid space-top"
        style={{ paddingRight: '0', paddingLeft: '0', marginTop: '-4em' }}
      >
        <div
          className="bgImage"
          style={{
            height: '390px',
            backgroundImage: `url("${this.props.vendor.image}")`,
            boxShadow: '0 3px 5px rgba(0, 0, 0, 0.2)',
            backgroundSize: 'cover',
            resize: 'both',
            borderBottom: '1px solid #00000010',
            paddingBottom: '10px',
            marginBottom: 0
          }}
        >
          {!this.props.store_loader ? (
            <div className="container-fluid">
              <div
                className="row "
                id="shiftRight"
                style={{ marginTop: '32px' }}
              >
                <div className="col-12 col-sm-4 " style={{ textAlign: 'left' }}>
                  <div
                    className="shadow-lg"
                    style={{
                      background: '#fff',
                      marginLeft: '-30px',
                      paddingRight: '20px',
                      paddingLeft: '50px',
                      paddingTop: '20px',
                      paddingBottom: '20px'
                    }}
                  >
                    <h3
                      style={{
                        fontWeight: 'bold',
                        textTransform: 'capitalize'
                      }}
                    >
                      {this.props.vendor.name}
                    </h3>
                    <h6
                      style={{
                        color: 'secondary',
                        paddingTop: '5px',
                        paddingBottom: '5px',
                        fontWeight: '300',
                        fontSize: '16px',
                        lineHeight: '16px'
                      }}
                    >
                      <i
                        className="fa fa-map-marker"
                        style={{
                          color: 'secondary',
                          marginRight: '15px',
                          fontWeight: '300',
                          fontSize: '16px',
                          lineHeight: '16px'
                        }}
                      ></i>
                      <b>{this.props.vendor.location}</b>
                    </h6>
                    <h6
                      style={{
                        color: 'secondary',
                        paddingTop: '5px',
                        paddingBottom: '5px',
                        fontWeight: '400',
                        fontSize: '16px',
                        lineHeight: '16px',
                        display: 'flex'
                      }}
                    >
                      <i
                        className="fa fa-tag"
                        style={{
                          color: 'secondary',
                          marginRight: '7px',
                          fontWeight: '300',
                          fontSize: '16px',
                          lineHeight: '16px'
                        }}
                      ></i>{' '}
                      <div>
                        {!this.props.loader ? (
                          category === 'Grocery' ? (
                            grocery_subcategory.map((subCategory) => (
                              <span key={subCategory}>{subCategory}</span>
                            ))
                          ) : category === 'Medicine' ? (
                            medicine_subcategory.map((subCategory) => (
                              <span
                                key={subCategory}
                                style={{
                                  textTransform: 'capitalize',
                                  fontSize: '14px'
                                }}
                              >
                                {' '}
                                •{subCategory} *
                              </span>
                            ))
                          ) : category === 'Liquor' ? (
                            liquor_subcategory.map((subCategory) =>
                              subCategory.includes(
                                this.props.match.params.subCategory
                              ) ? (
                                <span
                                  key={subCategory}
                                  style={{
                                    textTransform: 'capitalize',
                                    fontSize: '14px'
                                  }}
                                >
                                  {' '}
                                  •
                                  {subCategory.slice(
                                    0,
                                    subCategory.indexOf('(')
                                  )}{' '}
                                  *
                                </span>
                              ) : (
                                ''
                              )
                            )
                          ) : category === 'Restaurant' ? (
                            restaurant_subcategory.map((subCategory) => (
                              <span
                                key={subCategory}
                                className="mx-auto"
                                style={{
                                  textTransform: 'capitalize',
                                  fontSize: '13px'
                                }}
                              >
                                {' '}
                                •{subCategory}{' '}
                              </span>
                            ))
                          ) : category === 'Laundry' ? (
                            laundry_subcategory.map((subCategory) => (
                              <span
                                key={subCategory}
                                style={{
                                  textTransform: 'capitalize',
                                  fontSize: '14px'
                                }}
                              >
                                {' '}
                                •{subCategory}
                              </span>
                            ))
                          ) : category === 'Meat' ? (
                            meat_subcategory.map((subCategory) => (
                              <span
                                key={subCategory}
                                style={{
                                  textTransform: 'capitalize',
                                  fontSize: '14px'
                                }}
                              >
                                {' '}
                                •{subCategory}
                              </span>
                            ))
                          ) : category === 'Cider' ? (
                            cider_subcategory.map((subCategory) => (
                              <span
                                key={subCategory}
                                style={{
                                  textTransform: 'capitalize',
                                  fontSize: '14px'
                                }}
                              >
                                {' '}
                                •{subCategory}
                              </span>
                            ))
                          ) : category === 'MixedDrinks' ? (
                            mixeddrinks_subcategory.map((subCategory) => (
                              <span
                                key={subCategory}
                                style={{
                                  textTransform: 'capitalize',
                                  fontSize: '14px'
                                }}
                              >
                                {' '}
                                •{subCategory}
                              </span>
                            ))
                          ) : category === 'RedWine' ? (
                            redwine_subcategory.map((subCategory) => (
                              <span
                                key={subCategory}
                                style={{
                                  textTransform: 'capitalize',
                                  fontSize: '14px'
                                }}
                              >
                                {' '}
                                •{subCategory}
                              </span>
                            ))
                          ) : category === 'Spirits' ? (
                            spirits_subcategory.map((subCategory) => (
                              <span
                                key={subCategory}
                                style={{
                                  textTransform: 'capitalize',
                                  fontSize: '14px'
                                }}
                              >
                                {' '}
                                •{subCategory}
                              </span>
                            ))
                          ) : category === 'Champagne' ? (
                            champagne_subcategory.map((subCategory) => (
                              <span
                                key={subCategory}
                                style={{
                                  textTransform: 'capitalize',
                                  fontSize: '14px'
                                }}
                              >
                                {' '}
                                •{subCategory}
                              </span>
                            ))
                          ) : category === 'WhiteWine' ? (
                            whitewine_subcategory.map((subCategory) => (
                              <span
                                key={subCategory}
                                style={{
                                  textTransform: 'capitalize',
                                  fontSize: '14px'
                                }}
                              >
                                {' '}
                                •{subCategory}
                              </span>
                            ))
                          ) : (
                            ''
                          )
                        ) : (
                          <div>
                            <Loader
                              type="ThreeDots"
                              color="#d50000"
                              height={30}
                              width={30}
                              timeout={1000}
                            />
                          </div>
                        )}
                      </div>
                    </h6>
                    <h5
                      style={{
                        color: 'secondary',
                        paddingTop: '5px',
                        paddingBottom: '5px',
                        fontWeight: '300',
                        fontSize: '16px',
                        lineHeight: '16px'
                      }}
                    >
                      <i
                        className="fa fa-clock-o"
                        style={{
                          color: 'secondary',
                          marginRight: '6px',
                          fontWeight: '300',
                          fontSize: '16px',
                          lineHeight: '16px'
                        }}
                      ></i>{' '}
                      <b>
                        {/* {this.props.vendor.opentime} to{this.props.vendor.closetime}*/}{' '}
                        {(this.props.match.params.distance * 1.5 + 15).toFixed(
                          2
                        )}{' '}
                        mins | {this.props.match.params.distance}Km |{' '}
                        {difference > 0 ? (
                          <b style={{ color: '#36BA92' }}>
                            <i className="fa fa-check"></i> Open
                          </b>
                        ) : (
                          <b style={{ color: '#ce1d27' }}>
                            <i className="fa fa-times"></i> Closed
                          </b>
                        )}
                      </b>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <SkeletonLoad />
          )}
        </div>

        <section className="category-section spad" style={{ zIndex: '99' }}>
          <div className="container-fluid">
            <div className="row">
              <div
                className="col-lg-12"
                style={
                  this.state.thePosition === false
                    ? { textAlign: 'left', zIndex: '99' }
                    : {
                        position: 'fixed',
                        zIndex: '99',
                        background: 'white',
                        top: '55px',
                        paddingTop: '10px',
                        paddingBottom: '0px',
                        textAlign: 'left'
                      }
                }
              >
                <ul class="horizontal-menu" id="myHeaderSticky">
                  {!this.props.loader ? (
                    category === 'Grocery' ? (
                      grocery_subcategory.map((subCategory) => (
                        <li
                          key={subCategory}
                          className={
                            this.state.subCategory === subCategory
                              ? 'current'
                              : 'normal'
                          }
                        >
                          <Link
                            onClick={() => {
                              this.goto(subCategory);
                              this.setState({ subCategory: subCategory });
                            }}
                          >
                            {subCategory}
                          </Link>
                        </li>
                      ))
                    ) : category === 'Laundry' ? (
                      laundry_subcategory.map((subCategory) => (
                        <li
                          key={subCategory}
                          className={
                            this.state.subCategory === subCategory
                              ? 'current'
                              : 'normal'
                          }
                        >
                          <Link
                            onClick={() => {
                              this.goto(subCategory);
                              this.setState({ subCategory: subCategory });
                            }}
                          >
                            {subCategory}
                          </Link>
                        </li>
                      ))
                    ) : category === 'Meat' ? (
                      meat_subcategory.map((subCategory) => (
                        <li
                          key={subCategory}
                          className={
                            this.state.subCategory === subCategory
                              ? 'current'
                              : 'normal'
                          }
                        >
                          <Link
                            onClick={() => {
                              this.goto(subCategory);
                              this.setState({ subCategory: subCategory });
                            }}
                          >
                            {subCategory}
                          </Link>
                        </li>
                      ))
                    ) : category === 'Liquor' ? (
                      liquor_subcategory.map((subCategory) =>
                        subCategory.includes(
                          this.props.match.params.subCategory
                        ) ? (
                          <li
                            key={subCategory}
                            className={
                              this.state.subCategory === subCategory
                                ? 'current'
                                : 'normal'
                            }
                          >
                            <Link
                              onClick={() => {
                                this.goto(subCategory);
                                this.setState({ subCategory: subCategory });
                              }}
                            >
                              {subCategory.slice(0, subCategory.indexOf('('))}
                            </Link>
                          </li>
                        ) : (
                          ''
                        )
                      )
                    ) : category === 'Restaurant' ? (
                      restaurant_subcategory.map((subCategory) => (
                        <li
                          key={subCategory}
                          className={
                            this.state.subCategory === subCategory
                              ? 'current'
                              : 'normal'
                          }
                        >
                          <Link
                            style={{ fontWeight: 300 }}
                            onClick={() => {
                              this.goto(subCategory);
                              this.onPressCategory();
                              this.setState({ subCategory: subCategory });
                            }}
                          >
                            {subCategory}
                          </Link>
                        </li>
                      ))
                    ) : category === 'Food' ? (
                      food_subcategory.map((subCategory) => (
                        <li
                          key={subCategory}
                          className={
                            this.state.subCategory === subCategory
                              ? 'current'
                              : 'normal'
                          }
                        >
                          <Link
                            onClick={() => {
                              this.goto(subCategory);
                              this.setState({ subCategory: subCategory });
                            }}
                          >
                            {subCategory}
                          </Link>
                        </li>
                      ))
                    ) : category === 'Cider' ? (
                      cider_subcategory.map((subCategory) => (
                        <li
                          key={subCategory}
                          className={
                            this.state.subCategory === subCategory
                              ? 'current'
                              : 'normal'
                          }
                        >
                          <Link
                            onClick={() => {
                              this.goto(subCategory);
                              this.setState({ subCategory: subCategory });
                            }}
                          >
                            {subCategory}
                          </Link>
                        </li>
                      ))
                    ) : category === 'MixedDrinks' ? (
                      mixeddrinks_subcategory.map((subCategory) => (
                        <li
                          key={subCategory}
                          className={
                            this.state.subCategory === subCategory
                              ? 'current'
                              : 'normal'
                          }
                        >
                          <Link
                            onClick={() => {
                              this.goto(subCategory);
                              this.setState({ subCategory: subCategory });
                            }}
                          >
                            {subCategory}
                          </Link>
                        </li>
                      ))
                    ) : category === 'RedWine' ? (
                      redwine_subcategory.map((subCategory) => (
                        <li
                          key={subCategory}
                          className={
                            this.state.subCategory === subCategory
                              ? 'current'
                              : 'normal'
                          }
                        >
                          <Link
                            onClick={() => {
                              this.goto(subCategory);
                              this.setState({ subCategory: subCategory });
                            }}
                          >
                            {subCategory}
                          </Link>
                        </li>
                      ))
                    ) : category === 'Spirits' ? (
                      spirits_subcategory.map((subCategory) => (
                        <li
                          key={subCategory}
                          className={
                            this.state.subCategory === subCategory
                              ? 'current'
                              : 'normal'
                          }
                        >
                          <Link
                            onClick={() => {
                              this.goto(subCategory);
                              this.setState({ subCategory: subCategory });
                            }}
                          >
                            {subCategory}
                          </Link>
                        </li>
                      ))
                    ) : category === 'Champagne' ? (
                      champagne_subcategory.map((subCategory) => (
                        <li
                          key={subCategory}
                          className={
                            this.state.subCategory === subCategory
                              ? 'current'
                              : 'normal'
                          }
                        >
                          <Link
                            onClick={() => {
                              this.goto(subCategory);
                              this.setState({ subCategory: subCategory });
                            }}
                          >
                            {subCategory}
                          </Link>
                        </li>
                      ))
                    ) : category === 'WhiteWine' ? (
                      whitewine_subcategory.map((subCategory) => (
                        <li
                          key={subCategory}
                          className={
                            this.state.subCategory === subCategory
                              ? 'current'
                              : 'normal'
                          }
                        >
                          <Link
                            onClick={() => {
                              this.goto(subCategory);
                              this.setState({ subCategory: subCategory });
                            }}
                          >
                            {subCategory}
                          </Link>
                        </li>
                      ))
                    ) : (
                      ''
                    )
                  ) : (
                    <div>
                      <Loader
                        type="ThreeDots"
                        color="#d50000"
                        height={100}
                        width={100}
                        timeout={1000}
                      />
                    </div>
                  )}
                </ul>
              </div>

              <div
                className="col-lg-12 col-md-12 col-sm-12 "
                id="scrollingDiv"
                style={
                  this.state.thePosition === false
                    ? {
                        overflow: 'auto',
                        height: '80vh',
                        paddingLeft: '0',
                        marginTop: '0em'
                      }
                    : {
                        overflow: 'auto',
                        height: '80vh',
                        paddingLeft: '0',
                        marginTop: '0.3em'
                      }
                }
              >
                <div className="container-fluid">
                  <div
                    className="row"
                    style={{ paddingLeft: '20px', paddingTop: '13px' }}
                  >
                    <div className="col-12">
                      <h4
                        style={{
                          marginBottom: '-5px',
                          paddingBottom: 0,
                          textAlign: 'initial',
                          color: 'rgba(0, 0, 0)',
                          fontWeight: '400',
                          textTransform: 'capitalize'
                        }}
                      >
                        {this.props.vendor.name} Menu
                      </h4>
                    </div>
                    <div
                      className="col-12"
                      style={{
                        marginBottom: '-5px',
                        paddingBottom: 0,
                        textAlign: 'left',
                        color: '#112c50'
                      }}
                    >
                      <i
                        className="fa fa-window-minimize"
                        id="line"
                        aria-hidden="true"
                      ></i>
                      <i
                        className="fa fa-window-minimize"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>
                </div>

                <br />
                <div className="container-fluid">
                  <div className="row">
                    {!this.props.loader ? (
                      category === 'Grocery' ? (
                        grocery_subcategory.map((subName) => (
                          <div className="container" id={subName}>
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ textAlign: 'initial' }}
                              >
                                <h3
                                  style={{
                                    marginLeft: '10px',
                                    textAlign: 'initial',
                                    color: '#112c50',
                                    fontWeight: '400',
                                    textTransform: 'capitalize'
                                  }}
                                >
                                  {subName}
                                </h3>
                              </div>
                            </div>
                            <hr />
                            <div className="row">
                              {grocery_products.map((product) =>
                                product.sub_category === subName ? (
                                  <SingleProducts
                                    name={product.name}
                                    pid={product.pid}
                                    image={product.image}
                                    description={product.description}
                                    product={product}
                                    stock={product.stock}
                                    price={product.price}
                                    history={this.props.history}
                                  ></SingleProducts>
                                ) : null
                              )}
                            </div>
                          </div>
                        ))
                      ) : category === 'Medicine' ? (
                        medicine_subcategory.map((subName) => (
                          <div className="container" id={subName}>
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ textAlign: 'initial' }}
                              >
                                <h3
                                  style={{
                                    textAlign: 'initial',
                                    color: '#112c50',
                                    fontWeight: '400',
                                    textTransform: 'capitalize'
                                  }}
                                >
                                  {subName}
                                </h3>
                              </div>
                            </div>
                            <hr />
                            <div className="row">
                              {medicine_products.map((product) =>
                                product.sub_category === subName ? (
                                  <SingleProducts
                                    pid={product.pid}
                                    name={product.name}
                                    image={product.image}
                                    description={product.description}
                                    product={product}
                                    stock={product.stock}
                                    price={product.price}
                                    history={this.props.history}
                                  ></SingleProducts>
                                ) : null
                              )}
                            </div>
                          </div>
                        ))
                      ) : category === 'Liquor' ? (
                        liquor_subcategory.map((subName) =>
                          subName.includes(
                            this.props.match.params.subCategory
                          ) ? (
                            <div className="container" id={subName}>
                              <div className="row">
                                <div
                                  className="col-12"
                                  style={{ textAlign: 'initial' }}
                                >
                                  <h4>
                                    {subName.slice(0, subName.indexOf('('))}
                                  </h4>
                                </div>
                              </div>
                              <hr />
                              <div className="row">
                                {liquor_filter.map((product) =>
                                  product.sub_category === subName ? (
                                    <div className="col-12 col-lg-4 display p-4 mb-5">
                                      <h5>{product.name}</h5>
                                      <div className="row">
                                        {product.description.map((d, index) => (
                                          <div>
                                            {d === '' ? (
                                              <></>
                                            ) : (
                                              <>
                                                {' '}
                                                <div className="row">
                                                  <div className="col-4">
                                                    <img
                                                      src={product.image[index]}
                                                      alt=""
                                                      width="100%"
                                                    />
                                                    {/* <h2><span className="badge badge-info mt-5">$34.99</span></h2> */}
                                                  </div>
                                                  <div className="col-4">
                                                    <p>
                                                      {
                                                        product.description[
                                                          index
                                                        ]
                                                      }
                                                    </p>
                                                    {/* <h2><span className="badge badge-info mt-5 ">$34.99</span></h2> */}
                                                  </div>
                                                  <div className="col-4">
                                                    {+product.stock[index] >
                                                    0 ? (
                                                      <button
                                                        className="btn btnAdd"
                                                        onClick={(event) =>
                                                          this.handle(
                                                            event,
                                                            product,
                                                            index
                                                          )
                                                        }
                                                      >
                                                        {' '}
                                                        <i className="fa fa-plus"></i>{' '}
                                                        Add
                                                      </button>
                                                    ) : (
                                                      <button className="btn btnAdd">
                                                        {' '}
                                                        Out of stock
                                                      </button>
                                                    )}
                                                    <h4>
                                                      <span className="badge badge-info mt-4 ">
                                                        ${product.price[index]}
                                                      </span>
                                                    </h4>
                                                  </div>
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  ) : null
                                )}
                              </div>
                            </div>
                          ) : (
                            ''
                          )
                        )
                      ) : category === 'Restaurant' ? (
                        restaurant_subcategory.map((subName) => (
                          <Waypoint
                            fireOnRapidScroll="false"
                            key={subName}
                            topOffset="-220"
                            bottomOffset="2"
                            onLeave={() => {
                              this.setState({ subCategory: "bundle's" });
                            }}
                            onEnter={({
                              previousPosition,
                              currentPosition,
                              event
                            }) => {
                              this.setState({ subCategory: subName });
                            }}
                          >
                            <div
                              className="container-fluid element-important"
                              id={subName}
                              style={{ borderLeft: '0.5px solid lightgrey' }}
                            >
                              <div className="row">
                                <div
                                  className="col-12"
                                  style={{ textAlign: 'initial' }}
                                >
                                  {restaurant_subcategory[0] === subName ? (
                                    <h5
                                      className="mb-2 "
                                      style={{
                                        color: 'rgba(0, 0, 0)',
                                        fontWeight: '400',
                                        paddingLeft: '20px',
                                        textTransform: 'capitalize'
                                      }}
                                    >
                                      {subName}
                                    </h5>
                                  ) : (
                                    <h5
                                      className="mb-2 mt-3"
                                      style={{
                                        color: 'rgba(0, 0, 0)',
                                        fontWeight: '400',
                                        paddingLeft: '20px',
                                        textTransform: 'capitalize'
                                      }}
                                    >
                                      {subName}
                                    </h5>
                                  )}
                                </div>
                              </div>
                              {/* <hr/> */}
                              <div
                                className="row"
                                style={{ marginLeft: '1px' }}
                              >
                                {restaurant_products.map((product) =>
                                  product.sub_category === subName ? (
                                    <>
                                      <SingleProducts
                                        pid={product.pid}
                                        image={product.image}
                                        name={product.name}
                                        description={product.description}
                                        product={product}
                                        stock={product.stock}
                                        price={product.price}
                                        history={this.props.history}
                                      ></SingleProducts>
                                    </>
                                  ) : null
                                )}
                              </div>
                            </div>
                          </Waypoint>
                        ))
                      ) : category === 'Meat' ? (
                        meat_subcategory.map((subName) => (
                          <div
                            className="container-fluid"
                            id={subName}
                            style={{ borderLeft: '0.5px solid lightgrey' }}
                          >
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ textAlign: 'initial' }}
                              >
                                {meat_subcategory[0] === subName ? (
                                  <h5
                                    className="mb-2 "
                                    style={{
                                      color: 'rgba(0, 0, 0)',
                                      fontWeight: '400',
                                      paddingLeft: '20px',
                                      textTransform: 'capitalize'
                                    }}
                                  >
                                    {subName}
                                  </h5>
                                ) : (
                                  <h5
                                    className="mb-2 mt-3"
                                    style={{
                                      color: 'rgba(0, 0, 0)',
                                      fontWeight: '400',
                                      paddingLeft: '20px',
                                      textTransform: 'capitalize'
                                    }}
                                  >
                                    {subName}
                                  </h5>
                                )}
                              </div>
                            </div>
                            {/* <hr/> */}
                            <div className="row" style={{ marginLeft: '1px' }}>
                              {meat_products.map((product) =>
                                product.sub_category === subName ? (
                                  <>
                                    <SingleProducts
                                      pid={product.pid}
                                      image={product.image}
                                      name={product.name}
                                      description={product.description}
                                      product={product}
                                      stock={product.stock}
                                      price={product.price}
                                      history={this.props.history}
                                    ></SingleProducts>
                                  </>
                                ) : null
                              )}
                            </div>
                          </div>
                        ))
                      ) : category === 'Laundry' ? (
                        laundry_subcategory.map((subName) => (
                          <div
                            className="container-fluid"
                            id={subName}
                            style={{ borderLeft: '0.5px solid lightgrey' }}
                          >
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ textAlign: 'initial' }}
                              >
                                {laundry_subcategory[0] === subName ? (
                                  <h5
                                    className="mb-2 "
                                    style={{
                                      color: 'rgba(0, 0, 0)',
                                      fontWeight: '400',
                                      paddingLeft: '20px',
                                      textTransform: 'capitalize'
                                    }}
                                  >
                                    {subName}
                                  </h5>
                                ) : (
                                  <h5
                                    className="mb-2 mt-3"
                                    style={{
                                      color: 'rgba(0, 0, 0)',
                                      fontWeight: '400',
                                      paddingLeft: '20px',
                                      textTransform: 'capitalize'
                                    }}
                                  >
                                    {subName}
                                  </h5>
                                )}
                              </div>
                            </div>
                            {/* <hr/> */}
                            <div className="row" style={{ marginLeft: '1px' }}>
                              {laundry_products.map((product) =>
                                product.sub_category === subName ? (
                                  <>
                                    <SingleProducts
                                      pid={product.pid}
                                      image={product.image}
                                      name={product.name}
                                      description={product.description}
                                      product={product}
                                      stock={product.stock}
                                      price={product.price}
                                      history={this.props.history}
                                    ></SingleProducts>
                                  </>
                                ) : null
                              )}
                            </div>
                          </div>
                        ))
                      ) : category === 'Champagne' ? (
                        champagne_subcategory.map((subName) => (
                          <div className="container" id={subName}>
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ textAlign: 'initial' }}
                              >
                                <h3 style={{ color: '#112c50' }}>{subName}</h3>
                              </div>
                            </div>
                            <hr />
                            <div className="row">
                              {champagne_products.map((product) =>
                                product.sub_category === subName ? (
                                  <div className="col-12 col-lg-6 display p-4 mb-5">
                                    <h5>{product.name}</h5>
                                    <div className="row">
                                      {product.description.map((d, index) => (
                                        <div>
                                          {d === '' ? (
                                            <></>
                                          ) : (
                                            <>
                                              {' '}
                                              <div className="row">
                                                <div className="col-3">
                                                  <img
                                                    src={product.image[index]}
                                                    alt=""
                                                    width="100%"
                                                  />
                                                  {/* <h2><span className="badge badge-info mt-5">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-6">
                                                  <p>
                                                    {product.description[index]}
                                                  </p>
                                                  {/* <h2><span className="badge badge-info mt-5 ">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-3">
                                                  {+product.stock[index] > 0 ? (
                                                    <button
                                                      className="btn btnAdd"
                                                      onClick={(event) =>
                                                        this.handle(
                                                          event,
                                                          product,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      {' '}
                                                      <i className="fa fa-plus"></i>{' '}
                                                      Add
                                                    </button>
                                                  ) : (
                                                    <button className="btn btnAdd">
                                                      {' '}
                                                      Out of stock
                                                    </button>
                                                  )}
                                                  <h4>
                                                    <span className="badge badge-info mt-4 ">
                                                      ${product.price[index]}
                                                    </span>
                                                  </h4>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ) : null
                              )}
                            </div>
                          </div>
                        ))
                      ) : category === 'MixedDrinks' ? (
                        mixeddrinks_products.map((subName) => (
                          <div className="container" id={subName}>
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ textAlign: 'initial' }}
                              >
                                <h3 style={{ color: '#112c50' }}>{subName}</h3>
                              </div>
                            </div>
                            <hr />
                            <div className="row">
                              {mixeddrinks_products.map((product) =>
                                product.sub_category === subName ? (
                                  <div className="col-12 col-lg-6 display p-4 mb-5">
                                    <h5>{product.name}</h5>
                                    <div className="row">
                                      {product.description.map((d, index) => (
                                        <div>
                                          {d === '' ? (
                                            <></>
                                          ) : (
                                            <>
                                              {' '}
                                              <div className="row">
                                                <div className="col-3">
                                                  <img
                                                    src={product.image[index]}
                                                    alt=""
                                                    width="100%"
                                                  />
                                                  {/* <h2><span className="badge badge-info mt-5">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-6">
                                                  <p>
                                                    {product.description[index]}
                                                  </p>
                                                  {/* <h2><span className="badge badge-info mt-5 ">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-3">
                                                  {+product.stock[index] > 0 ? (
                                                    <button
                                                      className="btn btnAdd"
                                                      onClick={(event) =>
                                                        this.handle(
                                                          event,
                                                          product,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      {' '}
                                                      <i className="fa fa-plus"></i>{' '}
                                                      Add
                                                    </button>
                                                  ) : (
                                                    <button className="btn btnAdd">
                                                      {' '}
                                                      Out of stock
                                                    </button>
                                                  )}
                                                  <h4>
                                                    <span className="badge badge-info mt-4 ">
                                                      ${product.price[index]}
                                                    </span>
                                                  </h4>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ) : null
                              )}
                            </div>
                          </div>
                        ))
                      ) : category === 'RedWine' ? (
                        redwine_subcategory.map((subName) => (
                          <div className="container" id={subName}>
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ textAlign: 'initial' }}
                              >
                                <h3 style={{ color: '#112c50' }}>{subName}</h3>
                              </div>
                            </div>
                            <hr />
                            <div className="row">
                              {redwine_products.map((product) =>
                                product.sub_category === subName ? (
                                  <div className="col-12 col-lg-6 display p-4 mb-5">
                                    <h5>{product.name}</h5>
                                    <div className="row">
                                      {product.description.map((d, index) => (
                                        <div>
                                          {d === '' ? (
                                            <></>
                                          ) : (
                                            <>
                                              {' '}
                                              <div className="row">
                                                <div className="col-3">
                                                  <img
                                                    src={product.image[index]}
                                                    alt=""
                                                    width="100%"
                                                  />
                                                  {/* <h2><span className="badge badge-info mt-5">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-6">
                                                  <p>
                                                    {product.description[index]}
                                                  </p>
                                                  {/* <h2><span className="badge badge-info mt-5 ">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-3">
                                                  {+product.stock[index] > 0 ? (
                                                    <button
                                                      className="btn btnAdd"
                                                      onClick={(event) =>
                                                        this.handle(
                                                          event,
                                                          product,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      {' '}
                                                      <i className="fa fa-plus"></i>{' '}
                                                      Add
                                                    </button>
                                                  ) : (
                                                    <button className="btn btnAdd">
                                                      {' '}
                                                      Out of stock
                                                    </button>
                                                  )}
                                                  <h4>
                                                    <span className="badge badge-info mt-4 ">
                                                      ${product.price[index]}
                                                    </span>
                                                  </h4>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ) : null
                              )}
                            </div>
                          </div>
                        ))
                      ) : category === 'WhiteWine' ? (
                        whitewine_subcategory.map((subName) => (
                          <div className="container" id={subName}>
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ textAlign: 'initial' }}
                              >
                                <h3 style={{ color: '#112c50' }}>{subName}</h3>
                              </div>
                            </div>
                            <hr />
                            <div className="row">
                              {whitewine_products.map((product) =>
                                product.sub_category === subName ? (
                                  <div className="col-12 col-lg-6 display p-4 mb-5">
                                    <h5>{product.name}</h5>
                                    <div className="row">
                                      {product.description.map((d, index) => (
                                        <div>
                                          {d === '' ? (
                                            <></>
                                          ) : (
                                            <>
                                              {' '}
                                              <div className="row">
                                                <div className="col-3">
                                                  <img
                                                    src={product.image[index]}
                                                    alt=""
                                                    width="100%"
                                                  />
                                                  {/* <h2><span className="badge badge-info mt-5">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-6">
                                                  <p>
                                                    {product.description[index]}
                                                  </p>
                                                  {/* <h2><span className="badge badge-info mt-5 ">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-3">
                                                  {+product.stock[index] > 0 ? (
                                                    <button
                                                      className="btn btnAdd"
                                                      onClick={(event) =>
                                                        this.handle(
                                                          event,
                                                          product,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      {' '}
                                                      <i className="fa fa-plus"></i>{' '}
                                                      Add
                                                    </button>
                                                  ) : (
                                                    <button className="btn btnAdd">
                                                      {' '}
                                                      Out of stock
                                                    </button>
                                                  )}
                                                  <h4>
                                                    <span className="badge badge-info mt-4 ">
                                                      ${product.price[index]}
                                                    </span>
                                                  </h4>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ) : null
                              )}
                            </div>
                          </div>
                        ))
                      ) : category === 'Spirits' ? (
                        spirits_subcategory.map((subName) => (
                          <div className="container" id={subName}>
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ textAlign: 'initial' }}
                              >
                                <h3 style={{ color: '#112c50' }}>{subName}</h3>
                              </div>
                            </div>
                            <hr />
                            <div className="row">
                              {spirits_products.map((product) =>
                                product.sub_category === subName ? (
                                  <div className="col-12 col-lg-6 display p-4 mb-5">
                                    <h5>{product.name}</h5>
                                    <div className="row">
                                      {product.description.map((d, index) => (
                                        <div>
                                          {d === '' ? (
                                            <></>
                                          ) : (
                                            <>
                                              {' '}
                                              <div className="row">
                                                <div className="col-3">
                                                  <img
                                                    src={product.image[index]}
                                                    alt=""
                                                    width="100%"
                                                  />
                                                  {/* <h2><span className="badge badge-info mt-5">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-6">
                                                  <p>
                                                    {product.description[index]}
                                                  </p>
                                                  {/* <h2><span className="badge badge-info mt-5 ">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-3">
                                                  {+product.stock[index] > 0 ? (
                                                    <button
                                                      className="btn btnAdd"
                                                      onClick={(event) =>
                                                        this.handle(
                                                          event,
                                                          product,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      {' '}
                                                      <i className="fa fa-plus"></i>{' '}
                                                      Add
                                                    </button>
                                                  ) : (
                                                    <button className="btn btnAdd">
                                                      {' '}
                                                      Out of stock
                                                    </button>
                                                  )}
                                                  <h4>
                                                    <span className="badge badge-info mt-4 ">
                                                      ${product.price[index]}
                                                    </span>
                                                  </h4>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ) : null
                              )}
                            </div>
                          </div>
                        ))
                      ) : category === 'Food' ? (
                        food_subcategory.map((subName) => (
                          <div
                            className="container"
                            id={subName}
                            style={{ borderLeft: '1px solid lightgrey' }}
                          >
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ textAlign: 'initial' }}
                              >
                                <h3 style={{ color: '#112c50' }}>{subName}</h3>
                              </div>
                            </div>
                            <hr />
                            <div className="row" style={{ marginLeft: '1px' }}>
                              {food_products.map((product) =>
                                product.sub_category === subName ? (
                                  <SingleProducts
                                    pid={product.pid}
                                    name={product.name}
                                    image={product.image}
                                    description={product.description}
                                    product={product}
                                    stock={product.stock}
                                    price={product.price}
                                    history={this.props.history}
                                  ></SingleProducts>
                                ) : null
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        ''
                      )
                    ) : (
                      <div style={{ marginLeft: '21%' }}>
                        <Loader
                          type="ThreeDots"
                          color="#d50000"
                          height={100}
                          width={100}
                          timeout={1000}
                          style={{ 'margin-left': '200px' }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="container-fluid">
          <div className="row ">
            <div
              className="myBanner"
              style={{ textAlign: 'initial', marginBottom: '-1px' }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <h4 className="text-white">
                      Get anything from anywhere, at anytime
                    </h4>
                  </div>
                  <div className="col-12">
                    <p className="text-white">
                      Life is too short to waste it in finding the product you
                      need from thousands of products in your Favorite
                      supermarket, just click the photo of the product you need
                      and get it to deliver with Grospick.
                    </p>
                  </div>
                  <div className="col-12">
                    <p className="text-white">
                      Our trained shoppers will shop for you in the grocery
                      store and deliver to your home at the exact same price as
                      the stores. Want to eat at your favorite restaurant, but
                      they don't deliver? We will pick up your food and deliver
                      it in minutes. This is a new way of life. The very best in
                      your city, delivered in minutes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="container"
              style={{
                color: '#fff',
                background: '#fff',
                height: '1px',
                width: '92%'
              }}
            ></div>
          </div>
          <div className="row">
            <div
              className="myBanner"
              style={{
                backgroundImage:
                  'url(../../../../../img/footer.png), linear-gradient( 0deg, rgb(19, 25, 41) 0%, rgb(29, 36, 60) 100%)',
                backgroundPosition: 'bottom right'
              }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-1 col-md-1 mt-5">
                    <img src="../../../../../img/logo.png" alt="" />
                  </div>
                  <div className="col-2 col-md-2 footer-categorie">
                    {!auth ? (
                      <>
                        <h5
                          className="text-white footer-font"
                          style={{ paddingBottom: '3px', fontWeight: '700' }}
                        >
                          CUSTOMERS
                        </h5>
                        <Link
                          to="/vendor/login"
                          style={{ textDecoration: 'none' }}
                        >
                          <p
                            className="text-white footer-paragraph"
                            style={{
                              color: '#fff',
                              fontSize: '15px',
                              paddingBottom: '0px',
                              paddingTop: '2px',
                              marginBottom: '4px',
                              fontWeight: 400
                            }}
                          >
                            Vendor Login
                          </p>
                        </Link>
                      </>
                    ) : (
                      ''
                    )}
                    {!auth ? (
                      <Link
                        to="/admin/login"
                        style={{ textDecoration: 'none' }}
                      >
                        <p
                          className="text-white footer-paragraph"
                          style={{
                            color: '#fff',
                            fontSize: '15px',
                            paddingBottom: '0px',
                            marginBottom: '2px',
                            fontWeight: 400
                          }}
                        >
                          Admin Login
                        </p>
                      </Link>
                    ) : (
                      ''
                    )}
                    <Link to="" style={{ textDecoration: 'none' }}>
                      <p
                        className="text-white footer-paragraph"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          marginBottom: '2px',
                          fontWeight: 400
                        }}
                      >
                        Community service
                      </p>
                    </Link>
                  </div>
                  <div className="col-3 col-md-2" style={{ textAlign: 'left' }}>
                    <h5
                      className="text-white footer-font"
                      style={{ paddingBottom: '3px', fontWeight: '700' }}
                    >
                      GROSPICK
                    </h5>
                    <Link to="./about" style={{ textDecoration: 'none' }}>
                      <p
                        className="text-white footer-paragraph"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          paddingTop: '2px',
                          marginBottom: '4px',
                          fontWeight: 400
                        }}
                      >
                        About
                      </p>
                    </Link>
                    <Link to="#" style={{ textDecoration: 'none' }}>
                      <p
                        className="text-white footer-paragraph"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          marginBottom: '2px',
                          fontWeight: 400
                        }}
                      >
                        Jobs
                      </p>
                    </Link>
                    <Link to="./contact" style={{ textDecoration: 'none' }}>
                      <p
                        className="text-white footer-paragraph"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          marginBottom: '2px',
                          fontWeight: 400
                        }}
                      >
                        Contact Us
                      </p>
                    </Link>
                    <Link to="#" style={{ textDecoration: 'none' }}>
                      <p
                        className="text-white footer-paragraph"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          marginBottom: '2px',
                          fontWeight: 400
                        }}
                      >
                        Terms & Conditions
                      </p>
                    </Link>
                    <Link to="#" style={{ textDecoration: 'none' }}>
                      <p
                        className="text-white footer-paragraph"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          fontWeight: 400
                        }}
                      >
                        Privacy Policy
                      </p>
                    </Link>
                  </div>
                  <div className="col-3 col-md-2" style={{ textAlign: 'left' }}>
                    <h5
                      className="text-white footer-font"
                      style={{ paddingBottom: '3px', fontWeight: '700' }}
                    >
                      GET IN TOUCH
                    </h5>
                    <Link to="./contact" style={{ textDecoration: 'none' }}>
                      <p
                        className="text-white footer-paragraph"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          paddingTop: '2px',
                          marginBottom: '4px',
                          fontWeight: 400
                        }}
                      >
                        Email
                      </p>
                    </Link>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://twitter.com/grospick"
                      style={{ textDecoration: 'none' }}
                    >
                      <p
                        className="text-white footer-paragraph"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          marginBottom: '2px',
                          fontWeight: 400
                        }}
                      >
                        Twitter
                      </p>
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.facebook.com/Grospick-108163027510472/"
                      style={{ textDecoration: 'none' }}
                    >
                      <p
                        className="text-white footer-paragraph"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          marginBottom: '2px',
                          fontWeight: 400
                        }}
                      >
                        Facebook
                      </p>
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.instagram.com/grospicker/?hl=en"
                      style={{ textDecoration: 'none' }}
                    >
                      <p
                        className="text-white footer-paragraph"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          marginBottom: '2px',
                          fontWeight: 400
                        }}
                      >
                        Instagram
                      </p>
                    </a>
                    <a
                      target="_blank"
                      // href="#"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none' }}
                    >
                      <p
                        className="text-white footer-paragraph"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          fontWeight: 400
                        }}
                      >
                        LinkedIn
                      </p>
                    </a>
                  </div>
                  <div
                    className="col-3 col-md-2 footer-categorie2"
                    style={{
                      textAlign: 'left',
                      paddingRight: '0px',
                      paddingLeft: '0px'
                    }}
                  >
                    <h5
                      className="text-white footer-font"
                      style={{ paddingBottom: '3px', fontWeight: '700' }}
                    >
                      GET OUR APP
                    </h5>
                    <Link to="#" style={{ textDecoration: 'none' }}>
                      <p
                        className="text-white"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          paddingTop: '2px',
                          marginBottom: '4px',
                          fontWeight: 400
                        }}
                      >
                        <i
                          className="fa fa-android"
                          style={{ paddingRight: '3px' }}
                        ></i>{' '}
                        Android
                      </p>
                    </Link>
                    <Link to="#" style={{ textDecoration: 'none' }}>
                      <p
                        className="text-white"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          marginBottom: '2px',
                          fontWeight: 400
                        }}
                      >
                        <i
                          className="fa fa-apple"
                          style={{ paddingRight: '3px' }}
                        ></i>{' '}
                        Ios
                      </p>
                    </Link>
                    <Link to="#" style={{ textDecoration: 'none' }}>
                      <p
                        className="text-white"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          marginBottom: '2px',
                          fontWeight: 400
                        }}
                      >
                        <i
                          className="fa fa-desktop"
                          style={{ paddingRight: '4px' }}
                        ></i>{' '}
                        Desktop
                      </p>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <img src='./img/about.jpg'alt='footer'/> */}
        </div>
      </div>
    );
  }
}
const mapStateWithProps = (state) => ({
  vendors: state.user.vendors,
  products: state.user,
  vendor: state.shared.vendor,
  auth: state.user.auth,
  loader: state.ui.user_loading,
  store_loader: state.ui.store_loader
});

const mapDispatchToProps = (dispatch) => ({
  getAllProducts: (category, uid) => dispatch(getAllProducts(category, uid)),
  getSubCategoryProducts: (category, uid, subCategory) =>
    dispatch(getSubCategoryProducts(category, uid, subCategory)),
  getSubCategory: (category, uid) => dispatch(getSubCategory(category, uid)),
  getVendorDetails: (uid) => dispatch(getVendorDetails(uid))
});

export default connect(mapStateWithProps, mapDispatchToProps)(Shop);
